// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    // 47110 A7i: no words here: the user's language (and its catalog) is not known yet, and English would flash for a French user
    return <div style={{ padding: '20px', textAlign: 'center' }} aria-busy="true">…</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
